module.exports = __webpack_public_path__ + "static/media/gold-partner2.324fd56c.png";